import { VideoRequestStatus } from '../types/cctv.types';

export const getVideoRequestStatusText = (status: VideoRequestStatus) => {
  switch (status) {
    case VideoRequestStatus.Pending:
      return 'Pending';
    case VideoRequestStatus.DownloadedOnLocker:
      return 'Downloaded on Locker';
    case VideoRequestStatus.Executed:
      return 'Executed';
    case VideoRequestStatus.ExecutionFailed:
      return 'Execution Failed';
    case VideoRequestStatus.Expired:
      return 'Expired';
    case VideoRequestStatus.Canceled:
      return 'Canceled';
    case VideoRequestStatus.NoVideosFound:
      return 'No Videos Found'
    default:
      return 'Unknown';
  }
};
